
import { Vue, Component, Prop } from 'vue-property-decorator';

import StepProgress from './components/onBoardingStepper.vue';
import Step1 from './components/Steps/step1.vue';
import Step2 from './components/Steps/step2.vue';

import { User } from '@/generated/graphql';
@Component({
	components: {
		StepProgress,
		Step1,
		Step2,
	},
})
export default class PaymentV2 extends Vue {
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	steps = [
		{ label: 'Personal information' },
		{
			label: 'Review and Submit',
		},
	];
	activeStep: number = 0;
	record = null;
	onContinue(form) {
		this.record = {
			...form,
		};
		this.$router.replace({ query: {} });
		this.activeStep++;
	}
	goToPreviousStep() {
		if (this.activeStep > 0) {
			this.$router.push('?action=edit');
			this.activeStep--;
		}
	}
}
